// 开发环境不使用懒加载, 因为懒加载页面太多的话会造成webpack热更新太慢, 所以只有生产环境使用懒加载
const _import = require("./import-" + process.env.NODE_ENV)
const routes = [
    {
        path: "/",
        name: "index",
        component: _import("Home"),
    },
    {
        path: "/questionnaire",
        name: "questionnaire",
        component: _import("Questionnaire/index"),
    },
    {
        path: "/questionnaireDetails",
        name: "questionnaireDetails",
        component: _import("Questionnaire/details"),
    },
    {
        path: "/expertThinkTank",
        name: "expertThinkTank",
        component: _import("ExpertThinkTank"),
    },
    {
        path: "/company",
        name: "company",
        component: _import("Company"),
    },
    {
        path: "/schoolCooperation",
        name: "schoolCooperation",
        component: _import("SchoolCooperation"),
    },
    {
        path: "/news",
        name: "news",
        component: _import("News/index"),
    },
    {
        path: "/newsDetails",
        name: "newsDetails",
        component: _import("News/details"),
    },
    {
        path: "/contactus",
        name: "contactus",
        component: _import("Contactus"),
    },
    {
        path: "/productService",
        name: "productService",
        component: _import("ProductService"),
    },
    {
        path: "/recruit",
        name: "recruit",
        component: _import("Recruit"),
    },
    {
        path: "/journal",
        name: "journal",
        component: _import("Journal"),
    },
    {
        path: "/journalDetails",
        name: "journalDetails",
        component: _import("JournalDetails"),
    },
    {
        path: "/journalSubmit",
        name: "journalSubmit",
        component: _import("JournalSubmit"),
    }
]
module.exports = routes
